import React, { useContext, useEffect } from "react";
import { Menu, type MenuProps, theme } from "antd";
import Sider from "antd/es/layout/Sider";
import { RiFileSearchLine } from "react-icons/ri";
import { TiDocumentText } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { AuthContext } from "../../../../config/AuthContext";
import { MdOutlineCloudUpload } from "react-icons/md";
import { IoPeopleOutline } from "react-icons/io5";
import { FaListCheck } from "react-icons/fa6";

interface Props {
    setPantalla: (value: number) => void;
    pantalla: number;
    enunciats?: any[];
    refresh?: () => void;
    practicaNom?: string;
}

const AppSiderProblemesId = (props: Props) => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Web Dubtes';
    }, []);

    const baseItems: MenuProps['items'] = [
        {
            key: 'back',
            icon: <FaArrowLeft />,
            label: 'Tornar enrere',
            onClick: () => navigate('/jutge/practiques')
        },
        {
            type: 'divider'
        }
    ];

    // 🔹 Items per a alumnes
    const items: MenuProps['items'] = [
        ...baseItems,
        {
            key: '0',
            icon: <TiDocumentText />,
            label: 'Activitat',
            onClick: () => props.setPantalla(0),
        },
        {
            key: '1',
            icon: <MdOutlineCloudUpload />,
            label: 'Entrega',
            onClick: () => props.setPantalla(1),
        },
    ];

    // 🔹 Items per a professors / admins
    const itemsProfe: MenuProps['items'] = [
        ...items,
        {
            key: '2',
            icon: <IoPeopleOutline />,
            label: 'Alumnes',
            onClick: () => props.setPantalla(2),
        },
    ];

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Sider style={{ background: colorBgContainer }} width={200}>
            <Menu
                mode="inline"
                selectedKeys={[String(props.pantalla)]}
                style={{ height: '100%' }}
                items={["0", "1"].includes(user.tipus) ? itemsProfe : items}
            />
        </Sider>
    );
};

export default AppSiderProblemesId;

